import { PrimaryButton } from "components/Button/style";
import { DropdownSelect } from "components/DropdownSelect";
import { ModalCustom } from "components/ModalCustom";
import { Required } from "components/Required";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { OPCOES_PRENSA } from "../../constants/opcoesSolicitarAutorizacao";
import { IItemLote } from "../../interfaces/IItemLote";
import { elegivelParaAlterarPrensa } from "../../utils/alterarPrensaLote";
import {
  CaixaCampos,
  ContainerBotoes,
  TextoDescricao,
} from "../SolicitarAutorizacaoModal/style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  selecionados: IItemLote[];
  onConfirmar: (prensa: number) => Promise<boolean>;
  carregando: boolean;
}

export function AlterarPrensaModal({
  show,
  handleClose,
  selecionados,
  onConfirmar,
  carregando,
}: IProps) {
  const [prensa, setPrensa] = useState("");
  const elegiveis = selecionados.filter(elegivelParaAlterarPrensa).length;

  useEffect(() => {
    if (show) {
      setPrensa("");
    }
  }, [show]);

  async function confirmar() {
    if (await onConfirmar(Number(prensa))) {
      handleClose();
    }
  }

  const fecharSeLivre = carregando ? () => {} : handleClose;

  return (
    <ModalCustom
      show={show}
      handleClose={fecharSeLivre}
      title="Alterar prensa"
      centered
      footer
      footerTools={
        <ContainerBotoes>
          <PrimaryButton
            type="button"
            outline
            variante="primary"
            onClick={fecharSeLivre}
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            type="button"
            onClick={confirmar}
            disabled={!prensa || !elegiveis || carregando}
          >
            Alterar
          </PrimaryButton>
        </ContainerBotoes>
      }
    >
      <TextoDescricao>
        Selecione a prensa para fazer a alteração.
      </TextoDescricao>
      <CaixaCampos>
        <Form.Group>
          <Form.Label>
            Prensa <Required />
          </Form.Label>
          <DropdownSelect
            options={OPCOES_PRENSA}
            selectedValue={prensa}
            onSelect={setPrensa}
            required
          />
        </Form.Group>
      </CaixaCampos>
    </ModalCustom>
  );
}
